import { useEffect, useRef, useState } from "react";

interface ShareBarProps {
  title: string;
}

export default function ShareBar({ title }: ShareBarProps) {
  const [open, setOpen] = useState(false);
  const [toast, setToast] = useState("");
  const wrapRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const onClickOutside = (e: MouseEvent) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", onClickOutside);
    return () => document.removeEventListener("mousedown", onClickOutside);
  }, []);

  useEffect(() => {
    if (!toast) return;
    const t = window.setTimeout(() => setToast(""), 2000);
    return () => window.clearTimeout(t);
  }, [toast]);

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      setToast("链接已复制到剪贴板");
    } catch {
      setToast("复制失败，请手动复制地址栏链接");
    }
    setOpen(false);
  };

  const options = [
    { icon: "ri-weibo-fill", label: "分享到微博" },
    { icon: "ri-wechat-fill", label: "分享到微信" },
    { icon: "ri-link", label: "复制链接", action: copyLink },
  ];

  return (
    <div ref={wrapRef} className="relative">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
      >
        <i className="ri-share-forward-line text-base" />
        分享
      </button>

      {open && (
        <div className="absolute right-0 z-30 mt-2 w-48 overflow-hidden rounded-md border border-background-200 bg-background-50 py-1">
          {options.map((opt) => (
            <button
              key={opt.label}
              type="button"
              onClick={() => {
                if (opt.action) opt.action();
                else {
                  setToast(`已唤起「${opt.label}」分享（演示效果）`);
                  setOpen(false);
                }
              }}
              className="flex w-full items-center gap-2.5 px-4 py-2.5 text-left text-sm text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
            >
              <i className={`${opt.icon} text-base`} />
              {opt.label}
            </button>
          ))}
        </div>
      )}

      {toast && (
        <div className="fixed bottom-8 left-1/2 z-50 -translate-x-1/2 rounded-md bg-primary-900 px-5 py-3 text-sm text-background-50">
          {toast}
        </div>
      )}
    </div>
  );
}